import React from 'react';

const NoMatchScreen = () => {
    return (
        <div className="row frontendlumisoftnomatch">
            <div className="lumi-md-12 lumi-xs-12">
                <div className="lumisoftnomatchwrapper">
                    <h1 className="lumisoftnomatchtitle">404</h1>
                    <h3 className="textUppercase">Page not found!</h3>
                    <p className="lead">Seems you're looking for something that doesn't exist. </p>
                </div>
            </div>
        </div>
    );
};

export default NoMatchScreen;